import Backbone from 'backbone';
import _ from 'underscore';
import {
  formatCost,
  CONTEXTUAL_DELIVERY_STATUS,
} from '@bingads-webui-campaign/recommendation-core';

import template from './campaignVNext.pug';

export class CampaignContextualAttributeViewVNext extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
    isMCC,
    recommendationService,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.campaignId = targetId;
    this.isMCC = isMCC;
    this.campaignDeliveryStatusTitle = '';
    this.campaignDeliveryStatus = '';
    this.campaignType = '';
    this.campaignBudget = '';
    this.campaignBiddingType = '';
    this.eligibleStatusIcon = false;
    this.showStatusIcon = false;
    this.recommendationService = recommendationService;
  }


  render({
    showDeliveryStatusPopup,
    recommendationAccountId,
  }) {
    const {
      deps,
      campaignId,
      i18n,
    } = this;
    const options = this.isMCC ?
      {
        entitySet:
          deps
            .edmCampaign
            .currentCustomer
            .Accounts
            .$withKey(Number(recommendationAccountId))
            .Campaigns,
      } : {};

    deps.jsdata.Campaign.findAll({
      limit: 1,
      select: ['DeliveryStatus', 'CampaignType', 'Budget', 'BiddingScheme'],
      where: { Id: { $eq: campaignId } },
    }, options).then((response) => {
      if (response.length && response.length > 0) {
        const deliveryStatus = response[0].DeliveryStatus;
        const type = response[0].CampaignType;
        const budget = response[0].Budget ? response[0].Budget.Amount : null;
        const biddingType = response[0].BiddingScheme ? response[0].BiddingScheme.Type : null;

        this.campaignDeliveryStatusTitle = i18n.getString('Campaign_Delivery_Status');
        this.campaignDeliveryStatus = _.contains(CONTEXTUAL_DELIVERY_STATUS, deliveryStatus) ?
          i18n.getString(`Label_DeliveryStatus_${deliveryStatus}`) :
          i18n.getString('Contextual_Response_Null');
        this.campaignType = i18n.getString('Campaign_Type', {
          campaignType: type ?
            i18n.getString(`CampaignType_${type}`) :
            i18n.getString('Contextual_Response_Null'),
        });
        this.campaignBudget = i18n.getString('Campaign_Budget', {
          campaignBudget: budget ?
            i18n.getString('Campaign_Budget_Value', {
              campaignBudget: formatCost(budget, i18n, i18n.currency),
            }) :
            i18n.getString('Contextual_Response_Null'),
        });
        this.campaignBiddingType = i18n.getString('Campaign_Bidding_Type', {
          campaignBiddingType: biddingType ?
            i18n.getString(`BidStrategy_${biddingType}`) :
            i18n.getString('Contextual_Response_Null'),
        });

        if (this.campaignDeliveryStatus !== i18n.getString('Contextual_Response_Null')) {
          this.showStatusIcon = true;
        } else if (this.recommendationService) {
          this.recommendationService.currentActivity.trace(
            `unknown delivery status: "${deliveryStatus}" in campaign contextual attribute`,
            'recommendation/unKnownDeliveryStatus'
          );
        }
        if (this.campaignDeliveryStatus === i18n.getString('EntityStatus_Eligible')) {
          this.eligibleStatusIcon = true;
        }

        this.$el.html(template({
          i18n,
          campaignDeliveryStatusTitle: this.campaignDeliveryStatusTitle,
          campaignDeliveryStatus: this.campaignDeliveryStatus,
          campaignType: this.campaignType,
          campaignBudget: this.campaignBudget,
          campaignBiddingType: this.campaignBiddingType,
          showStatusIcon: this.showStatusIcon,
          eligibleStatusIcon: this.eligibleStatusIcon,
        }));

        showDeliveryStatusPopup(this.el.outerHTML);
      }
    });
    return this;
  }
}
